<template>
  <div>
    <div style="z-index: 1000 !important;" class="floated-chat-btn" @click="abrirModalPickear()"
      v-if="tarea.fecha_asignacion">
      <i class="fas fa-check"></i>&nbsp;&nbsp;Pickear
    </div>
    <div class="modal fade" id="pickearModal" role="dialog" tabindex="-1" aria-hidden="true" style="display: none;">
      <div class="modal-dialog" role="document">
        <div class="modal-content" style="background-color: rgba(255, 255, 255, 0.98);">
          <div class="modal-header">
            <h5 class="modal-title">Picking Producto</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <h6 style="color: blue; text-align: left;" v-if="producto">
              {{ producto.sku }}
              <br />
              {{ producto.nombre }}
              <br />
              Pendiente: {{ current_producto.pendiente_pickear }} &nbsp;
              Existencia:
              <span v-bind:class="{
                'text-danger': existencia < 0,
              }">{{ existencia }}</span>
            </h6>
            <small v-if="errors" class="form-text text-danger">{{
              errors.producto
            }}</small>
            <div class="form-group" v-if="!producto">
              <label for>Producto:</label>
              <input @change="refreshProducto(barra)" class="form-control" placeholder="Código de Barra" ref="barrax"
                type="text" v-model="barra" />
              <small v-if="error_pickeo && error_pickeo.barra" class="form-text text-danger">{{ error_pickeo.barra
              }}</small>
            </div>
            <button v-else @click="refreshDetalleDefault()" class="btn btn-dark btn-md btn-block">
              Cambiar Producto
              <i class="fas fa-redo-alt"></i>
            </button>
            <br>
            <div class="row">
              <div class="col-sm-6" v-if="producto">
                <div class="form-group">
                  <label for>Localización</label>
                  <input class="form-control" ref="barraLoc" @change="inputFocusCantidad()"
                    placeholder="Barra de Posición" type="text" v-model="localizacion_origen" />
                  <small v-if="error_pickeo && error_pickeo.localizacion_origen" class="form-text text-danger">{{
                    error_pickeo.localizacion_origen }}</small>
                </div>
              </div>
              <div class="col-sm-6" v-if="producto">
                <div class="form-group">
                  <label for>Cantidad</label>
                  <input class="form-control" placeholder="Unidades" type="number" ref="cantidadx" step="0.01"
                    v-model="cantidad" />
                </div>
                <small v-if="error_pickeo && error_pickeo.cantidad" class="form-text text-danger">{{ error_pickeo.cantidad
                }}</small>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-block btn-primary" type="button" @click="pickear">
              Pick
              <i class="fas fa-check"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DynamicService from "@/services/commons/DynamicService";
import Notifications from "@/notifications/notifications";

export default {
  components: {},
  props: {
    tarea: {
      type: Object,
    },
  },
  data() {
    return {
      current_producto: {
        pendiente_pickear: "",
      },
      errors: {
        producto: "",
      },
      error: [],
      error_pickeo: [],
      barra: null,
      localizacion_origen: null,
      cantidad: null,
      lote: null,
      producto: "",
      existencia: "",
    };
  },
  mounted() {
    let self = this;
    $(".modal").on("shown.bs.modal", function () {
      // $(this).find('[autofocus]').focus();
      self.$refs.barrax.focus();
    });
  },
  methods: {
    inputFocusCantidad() {
      this.$refs.cantidadx.focus();
    },
    abrirModalPickear() {
      let self = this;
      self.refreshDetalleDefault();
      $("#pickearModal").modal("show");
    },
    filtrar_detalle_tarea(producto) {
      let self = this;
      self.current_producto = self.tarea.detalle.filter(function (det) {
        return det.producto == producto.sku;
      });
      if (self.current_producto.length == 0) {
        self.errors.producto = "Producto no existe en la tarea";
        return;
      }
      self.producto = producto;
      self.current_producto = self.current_producto[0];
      setTimeout(function () {
        self.$refs.barraLoc.focus();
      }, 200);
    },
    refreshDetalleDefault() {
      let self = this;
      self.error_pickeo = "";
      self.producto = null;
      self.barra = "";
      self.cantidad = "";
      self.localizacion_origen = "";
      self.posicion = "";
      self.errors.producto = "";
    },
    refreshProducto(barra) {
      let self = this;
      if (!barra) {
        self.errors.producto = "Este campo no puede ser nulo";
        return;
      }
      DynamicService.fetch("cat", "producto-barra", {
        barra: barra,
        estatus: true,
      })
        .then((response) => {
          let producto = response.data.results[0].producto_obj;
          self.errors.producto = "";
          self.filtrar_detalle_tarea(producto);
          self.existenciaProductoTienda(producto);
          self.error_pickeo = "";
        })
        .catch((err) => {
          self.producto = null;
          self.errors.producto = "No existe producto";
        });
    },
    existenciaProductoTienda(producto) {
      let self = this;
      DynamicService.getAction(
        "cat",
        "productos",
        producto.sku,
        "existencia_producto_tienda",
        {
          tienda: self.tarea.tienda_origen,
        }
      )
        .then((response) => {
          self.existencia = response.data.cantidad;
        })
        .catch((error) => {
          alert("error");
          console.log(error.response.data);
          1;
        });
    },
    pickear() {
      let self = this;
      DynamicService.postAction("wms", "tareas", self.tarea.id, "pickear", {
        barra: self.barra,
        localizacion_origen: self.localizacion_origen,
        cantidad: self.cantidad,
        /*
        Por el momento no se envía el lote. 
        lote: self.lote,
        */
      })
        .then((res) => {
          $("#pickearModal").modal("hide");
          self.refreshDetalleDefault();
          self.data = {
            error_pickeo: null,
            barra: null,
            localizacion_origen: null,
            cantidad: null,
            lote: null,
          };
          Notifications.alert.success(
            "Pickear producto",
            "Realizado exitosamente"
          );
          self.$emit("refresh_tarea");
        })
        .catch((err) => {
          if (err.response.data) {
            self.error_pickeo = err.response.data;
          }
          if (self.error_pickeo && self.error_pickeo.detail) {
            Notifications.alert.error(
              "Pickear tarea",
              err.response.data.detail
            );
          }
        });
    },
  },
};
</script>